// extracted by mini-css-extract-plugin
export var box = "_1b-2";
export var checkboxControl = "_1b-0";
export var checkboxRow = "_1b-a";
export var checked = "_1b-3";
export var descriptionSpacer = "_1b-c";
export var disabled = "_1b-4";
export var icon = "_1b-8";
export var input = "_1b-1";
export var labelSpacer = "_1b-b";
export var large = "_1b-7";
export var medium = "_1b-6";
export var small = "_1b-5";
export var text = "_1b-9";